import { render, staticRenderFns } from "./ModalLightEnergyRecord.vue?vue&type=template&id=72a633b8&scoped=true"
import script from "./ModalLightEnergyRecord.vue?vue&type=script&lang=js"
export * from "./ModalLightEnergyRecord.vue?vue&type=script&lang=js"
import style0 from "./ModalLightEnergyRecord.vue?vue&type=style&index=0&id=72a633b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a633b8",
  null
  
)

export default component.exports